import React from "react";

export default function ForPsychologists() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Для психологов</h2>

      <h3>Как попасть в каталог</h3>
      <p>
          Чтобы быть размещённым в каталоге БЛИЗКО, специалисту необходимо состоять в сообществе БЛИЗКО.
      </p>

        <p>
            В связи с текущей ситуацией площадки активности сообщества меняются, для вступления в сообщество
            свяжитесь с нами по телефону <a href='tel:79781907732'>+7978 190-77-32</a> или напишите по доступным контактам.
        </p>

      <h3>Условия размещения</h3>
      <ul>
        <li>Активность в сообществе БЛИЗКО</li>
        <li>Опыт работы от 1 года</li>
        <li>Готовность предоставлять достоверную информацию</li>
        <li>Соблюдение этического кодекса психолога</li>
      </ul>

    </div>
  );
}
